import { useShouldShowAlphaTestingFeature } from './_base';

export const useCanAccessInternalRoutes = useShouldShowAlphaTestingFeature;
